/**
 * A module's own facilitator actions (manifest admin.actions) in its Työpaja
 * section (#1213, specs/facilitator-console.md → shelf 3). Shown for every step,
 * live or not, with each action's latest job; the flow bar draws the live
 * module's on top of these. Platform code: it knows no module.
 */
import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from '../../hooks/useTranslation.jsx';
import useModuleFlowActions from '../../hooks/useModuleFlowActions';
import { ModuleActionButtons } from './ModuleFlowActions';

const Note = styled.div`
  margin: 0 0 16px;
  padding: 10px 14px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.03);
  color: ${(p) => (p.$tone === 'error' ? '#fca5a5' : 'rgba(255, 255, 255, 0.6)')};
  font-size: 13px;
`;

/**
 * @param {{ instanceId: string, stepId: string, actions: object[] }} props
 *   `actions` is the manifest list, used only to know whether there is anything to fetch.
 */
export default function ModuleActionsShelf({ instanceId, stepId, actions = [] }) {
  const { t } = useTranslation();
  // Only a step whose module declares actions asks the server for them.
  const flow = useModuleFlowActions(instanceId, actions.length ? stepId : null);
  if (!actions.length) return null;
  if (flow.error === 'signin') return <Note>{t('workshopOrchestrator.moduleActions.signin')}</Note>;
  if (flow.error) return <Note $tone="error">{flow.error}</Note>;
  return <ModuleActionButtons actions={flow.actions} onRun={flow.run} />;
}
